import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PhysicalConfirmationService from '../../../../services/PhysicalConfirmationService';
import { translate, showMessageToast, isNullOrEmpty, convertToUppercase, configs, showMessageToastCustom, groupBy, getPreAllocationArea } from '../../../../utils/util';
import { ENUMS, VISIONS } from '../../../../utils/constants';
import { Input, BackButton, Select, RadioButton, SelectDock } from '../../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import ButtonUI from '../../../../components/UI/ButtonUI';
import { startProcessing, endProcessing } from '../../../../actions/loadingAction';
import { getVision } from '../../../../services/auth';
import useStateWithPromise from '../../../../utils/useEffectUpdate';

const MasterCimReceipt = (props) => {
    const [receipts, setReceipts] = useState([]);
    const [receiptsDeem, setReceiptsDeem] = useState([]);
    const [listPallets, setListPallets] = useStateWithPromise([]);
    const [model, setModel] = useState({
        place: 1,
        mdr: props.filter?.truckKanban ? "PLT" : undefined,
        preAllocation: props.filter?.truckKanban ? 'S' : undefined,
        preAllocationArea: props.filter?.truckKanban ? 'XD%' : getPreAllocationArea(getVision()),
        pallets: 1,
        print: (getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) ? ENUMS.ePrintTypes.Click.value : props.printSelect,
    });

    useEffect(() => {
        if (getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) {
            props.setPrintSelect(ENUMS.ePrintTypes.Click.value)
        }
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        const dataItem = props.location?.state?.receipts;
        if (dataItem && dataItem.length > 0) {
            model.mdr = props.filter?.truckKanban ? "PLT" : dataItem[0].mdr
            setReceipts([...dataItem]);
            setModel({ ...model });
        }
        // eslint-disable-next-line
    }, [props.location?.state?.receipts]);

    useEffect(() => {
        onCalcBalancePallet();
        // eslint-disable-next-line
    }, [model.pallets, receipts]);

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    const getConfig = () => {
        return configs(ENUMS.eModules.PhysicalConfirmation.value, props.config?.items)
    }

    const onCalcBalancePallet = () => {

        let arrayDeem = []
        if (receipts.length > 0) {
            receipts.forEach(r => {
                var total = (r.qtStorage * r.qtItems) * model.pallets
                if (total > r.balance) {
                    arrayDeem.push({
                        partNumberDescription: r.partNumberDescription,
                        partNumberCode: r.partNumberCode,
                        id: r.id,
                        balance: r.balance,
                        total: total
                    })
                }
            });
        }

        return setReceiptsDeem([...arrayDeem]);
    };

    const onChangeDate = (receipt, event) => {
        const receiptsUpdates = [];
        Object.assign(receiptsUpdates, receipts);
        const receiptUpdate = receiptsUpdates.find((i) => { return i.id === receipt.id; });
        if (receiptUpdate !== undefined) {
            if (receiptUpdate.perishable === 'P') {
                receiptUpdate.productionDate = event.target.value;
            }
            if (receiptUpdate.perishable === 'V') {
                receiptUpdate.expirationDate = event.target.value;
            }
        }

        setReceipts(receiptsUpdates);
    };

    const isValidSubmit = () => {
        var findRequiredDate = receipts.find((item) =>
            (item.perishable === 'P' && !item.productionDate) ||
            (item.perishable === 'V' && !item.expirationDate)
        )
        if (findRequiredDate !== undefined) {
            showMessageToast({ html: translate('date-required', 'physical-confirmation'), classes: 'red' });
            return false;
        }

        if (model.print === ENUMS.ePrintTypes.Click.value && ((onChangeResource() ?? "") === "")) {
            showMessageToastCustom(translate('warning', 'general'), translate('missing-click-resource-name', 'validations'), 3000, 'mdi mdi-alert-circle-outline red-text');
            return false;
        }

        if (receipts.find(f => isNullOrEmpty(f.mdr) && isNullOrEmpty(model.mdr))) {
            showMessageToastCustom(translate('warning', 'general'), "Existe Desenhos sem MDR, favor preenche", 3000, 'mdi mdi-alert-circle-outline red-text');
            return false;
        }

        return true;
    };

    const onChangeResource = () => {
        try {
            if (!isNullOrEmpty(props.user.resource)) {
                const resource = props.resources.find((i) => i.resourceId === parseInt(props.user.resource));
                return model.print === ENUMS.ePrintTypes.Click.value && !isNullOrEmpty(resource.clickResourceName) ? resource.clickResourceName : resource.name;
            }
            return "";
        } catch (error) {
            console.log(error);
            return "";
        }
    }

    const createdPalletTruckKanban = () => {
        var shed = "";
        var dock = "M01";
        model.preAllocation = "S";
        model.preAllocationArea = 'XD%';
        var multipleSheds = groupBy(receipts, "shed");
        var listGroup = [];

        for (let index = 0; index < multipleSheds.length; index += 1) {
            const element = multipleSheds[index].value;
            var listTk = [];

            for (let i = 0; i < element.length; i += 1) {
                const r = element[i];
                listTk.push({
                    id: r.id,
                    resource: onChangeResource(),
                    printer: props.user.printer,
                    preAllocationArea: model.preAllocationArea,
                    preAllocation: model.preAllocation,
                    print: model.print,
                    productionDate: r.productionDate,
                    expirationDate: r.productionDate,
                    dock: dock,
                    shed: shed,
                    remainingBalance: r.remainingBalance,
                    mdr: isNullOrEmpty(model.mdr) ? r.mdr : model.mdr,
                    boxQuantity: parseInt(r.qtStorage),
                    boxQuantityItems: r.qtItems,
                    quantityLocation: r.quantityLocation,
                    mvi: props.filter?.mvi,
                    truckKanban: props.filter?.truckKanban
                })
            }

            listGroup.push({
                idPallet: index + 1,
                arrayItems: listTk
            });
        }

        setListPallets([...listGroup]).then(() => {
            sendPallets(listGroup);
        });

    }

    const createdPallet = (items, multipleJourney) => {
        var shed = props.sheds.find((i) => i.id === props.user?.shed)?.code;
        var dock = props.user.dock;

        if (parseInt(model.place || 0) === 2) {
            model.preAllocation = "N";
            model.preAllocationArea = dock;
        } else {
            model.preAllocation = "S";
        }

        var listGroup = [];

        items.forEach(r => {
            listGroup.push({
                id: r.id,
                resource: onChangeResource(),
                printer: props.user.printer,
                preAllocationArea: model.preAllocationArea,
                preAllocation: model.preAllocation,
                print: model.print,
                productionDate: r.productionDate,
                expirationDate: r.productionDate,
                dock: dock,
                shed: shed,
                remainingBalance: r.remainingBalance,
                mdr: isNullOrEmpty(model.mdr) ? r.mdr : model.mdr,
                boxQuantity: parseInt(r.qtStorage),
                boxQuantityItems: r.qtItems,
                mvi: props.filter?.mvi,
                truckKanban: props.filter?.truckKanban
            })
        });

        if (!Boolean(getConfig()?.masterCimPallets)) {
            props.insertInstantConfirmationReceipt(listGroup, (r, physicalConfirmationIds) => {
                if (!multipleJourney) {
                    callbackSearch();
                }
            });
        } else {
            for (let index = 0; index < model.pallets; index += 1) {
                listPallets.push({
                    idPallet: index + 1,
                    arrayItems: listGroup
                });
                setListPallets([...listPallets]);
            }

            sendPallets(listPallets, shed);
        }
    }

    const submit = () => {
        try {
            if (receipts.length > 0 && isValidSubmit()) {
                if (props.filter?.truckKanban) {
                    createdPalletTruckKanban();
                } else {
                    var multipleJourney = groupBy(receipts, "journey");

                    if (multipleJourney.length > 1) {
                        for (let index = 0; index < multipleJourney.length; index += 1) {
                            const element = multipleJourney[index].value;
                            createdPallet(element, index !== multipleJourney.length - 1);
                        }
                    } else {
                        createdPallet(receipts, false);
                    }
                }
            }

        } catch (error) {
            props.hideLoading();
        }
    }

    const sendPallets = (pallets, shed) => {
        var item = pallets[0];
        showMessageToastCustom(translate('general.info'), `Enviando pallet ${item.idPallet}`, 8000, 'mdi mdi-checkbox-marked-circle-outline green-text');
        props.insertInstantConfirmationReceipt(item.arrayItems, () => {
            pallets = pallets?.filter((i) => i.idPallet !== item.idPallet);
            setListPallets([...pallets]);
            if (pallets.length > 0) {
                sendPallets(pallets, shed);
            } else {
                callbackSearch()
            }
        });
    }

    const callbackSearch = () => {
        var shed = !Boolean(getConfig()?.shedRequiredPhysicalConfirmation) || props.filter?.truckKanban ? "" : props.sheds.find((i) => i.id === props.user.shed).code;
        props.resetReceipsGroup();
        if (getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD && (!isNullOrEmpty(props.physicalConfirmation?.mvmNumber) || !isNullOrEmpty(props.physicalConfirmation?.journey || props.receiptIds.length > 0))) {
            let filterDto = {
                mvmNumber: props.filter.mvmNumber,
                journey: props.filter.journey,
                supplier: props.filter.supplier,
                invoice: props.filter.invoice,
                truckKanban: props.filter?.truckKanban,
                shed: shed,
                dock: !props.filter?.truckKanban ? props.user.dock : '',
                pending: true,
                receiptIds: props.receiptIds
            }
            props.showLoading("Atualizando...");
            props.search(filterDto, () => {
                props.hideLoading();
            });
        } else {
            props.hideLoading();
        }
        props.history.go(-1);
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container">
                <div className="card">
                    <div className="card-content" style={{ padding: '15px', paddingBlockEnd: '1px' }}>
                        {
                            !props.filter?.truckKanban &&
                            <>
                                <RadioButton
                                    defaultChecked={(model.place || "").toString()}
                                    name='place'
                                    onChange={(e) => onChange(e)}
                                    label={translate('select-storage-area', 'physical-confirmation')}
                                    items={[
                                        { id: "1", label: translate('storage', 'physical-confirmation') },
                                        { id: "2", label: translate('entrance-area', 'physical-confirmation') },
                                    ]}
                                />
                                {
                                    getVision() === VISIONS.Jeep && parseInt(model.place || 0) === 2 &&
                                    <SelectDock
                                        unload="true"
                                        required
                                        id="preAllocationArea"
                                        name="preAllocationArea"
                                        filterArea
                                        shedId={props.user.shed}
                                        value={props.user.dock}
                                        onChange={onChange}
                                    />
                                }
                                {
                                    getVision() !== VISIONS.Jeep && parseInt(model.place || 0) === 2 &&
                                    <Input
                                        required
                                        id="preAllocationArea"
                                        name="preAllocationArea"
                                        defaultValue={props.filter?.truckKanban ? 'XD%' : props.user.dock}
                                        disabled
                                        onKeyUp={convertToUppercase}
                                    />
                                }
                                {parseInt(model.place || 0) === 1 &&
                                    <div className="input-field no-padding col s12" style={{ marginTop: '20px' }}>
                                        <Input
                                            required={parseInt(model.place || 0) === 2}
                                            label={translate('pre-allocation-area', 'physical-confirmation')}
                                            id="preAllocationArea"
                                            name="preAllocationArea"
                                            type="text"
                                            defaultValue={model.preAllocationArea || ""}
                                            onChange={onChange}
                                            onKeyUp={convertToUppercase}
                                        />
                                    </div>
                                }
                            </>
                        }
                        <div className="input-field no-padding col s9" style={{ paddingBottom: '5px', paddingTop: '20px' }}>
                            <Input
                                id="mdr"
                                name="mdr"
                                type="text"
                                label={translate('mdr-pallets', 'physical-confirmation')}
                                onChange={onChange}
                                defaultValue={model.mdr || ''}
                                onKeyUp={convertToUppercase}
                            />
                        </div>
                        {
                            Boolean(getConfig().masterCimPallets) &&
                            <div className="input-field no-padding col s9" style={{ paddingBottom: '5px', paddingTop: '20px' }}>
                                <Input
                                    id="pallets"
                                    name="pallets"
                                    type="number"
                                    label={translate('qtd-pallets', 'physical-confirmation')}
                                    required
                                    onChange={onChange}
                                    defaultValue={model.pallets}
                                />
                            </div>
                        }
                        {
                            !props.filter?.truckKanban &&
                            <div className="input-field">
                                <Select
                                    required
                                    id="print"
                                    name="print"
                                    display="name"
                                    label={translate('print-type', 'physical-confirmation')}
                                    placeHolder={translate('choose-one-option', 'general')}
                                    data={[
                                        { id: ENUMS.ePrintTypes.Logistics.value, text: translate(ENUMS.ePrintTypes.Logistics.text, 'physical-confirmation') },
                                        { id: ENUMS.ePrintTypes.Click.value, text: translate(ENUMS.ePrintTypes.Click.text, 'physical-confirmation') },
                                        { id: ENUMS.ePrintTypes.NotPrint.value, text: translate(ENUMS.ePrintTypes.NotPrint.text, 'physical-confirmation') },
                                    ]}
                                    change={(e) => {
                                        props.setPrintSelect(e.target.value);
                                        onChange(e);
                                    }}
                                    defaultValue={model.print}
                                />
                            </div>
                        }

                        <div style={{ marginTop: '10px' }}>
                            {receipts.map((item, index) => (
                                <div key={`${item.partNumberCode} - ${index}`} style={{ marginBottom: '20px' }}>
                                    {
                                        receiptsDeem.filter(f => f.id === item.id && f.partNumberCode === item.partNumberCode).length > 0 ?
                                            <p style={{ marginBottom: '-7px', color: "red" }}>{`${item.partNumberDescription}  ${item.partNumberCode} DEEM`}</p>
                                            :
                                            <p style={{ marginBottom: '-7px' }}>{`${item.partNumberDescription}  ${item.partNumberCode}`}</p>
                                    }
                                    {
                                        item.perishable !== 'N' &&
                                        <Input
                                            type="date"
                                            label={item.perishable === 'P' ? translate('production-date', 'physical-confirmation') : translate('expiration-date', 'physical-confirmation')}
                                            id={item.perishable === 'P' ? 'productionDate' : 'expirationDate'}
                                            name={item.perishable === 'P' ? 'productionDate' : 'expirationDate'}
                                            onChange={(e) => {
                                                onChangeDate(item, e);
                                            }}
                                            required
                                            className="sixth-text-color"
                                        />
                                    }
                                </div>
                            ))}
                        </div>
                        <div className="row" style={{ margin: '10px 0 15px 0' }}>
                            <div className="col s12">
                                <ButtonUI onClick={() => submit()} full="true" text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        receipts: state.physicalConfirmationReducer.receipts,
        areas: state.areaReducer.areas,
        user: state.userReducer.user,
        config: state.configReducer.config,
        sheds: state.configReducer.sheds,
        physicalConfirmation: state.physicalConfirmationReducer.physicalConfirmation,
        printLabel: state.physicalConfirmationReducer.printLabel,
        resources: state.logisticsResourceReducer.list,
        printSelect: state.physicalConfirmationReducer.printSelect,
        receiptIds: state.physicalConfirmationReducer.receiptIds,
        filter: state.physicalConfirmationReducer.filter,
        physicalConfirmationList: state.physicalConfirmationReducer.physicalConfirmationList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        showLoading: (message) => {
            dispatch(startProcessing(message));
        },
        hideLoading: () => {
            dispatch(endProcessing());
        },
        insertInstantConfirmationReceipt: (list, callback) => {
            dispatch(PhysicalConfirmationService.insertConfirmationGroup(list, callback));
        },
        resetReceipsGroup: () => {
            dispatch(PhysicalConfirmationService.resetReceipsGroup());
        },
        setActiveTab: (tabIndex) => {
            dispatch(PhysicalConfirmationService.setActiveTab(tabIndex));
        },
        search: (filter, callback) => {
            dispatch(PhysicalConfirmationService.search(filter, callback));
        },
        setPrintSelect: (printSelect) => {
            dispatch(PhysicalConfirmationService.setPrintSelect(printSelect));
        },
        searchList: (filter, callback) => {
            dispatch(PhysicalConfirmationService.searchList(filter, callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MasterCimReceipt));